<template>
    <div>
        <div class="container">
            <h1>{{ $t('Widget') }}</h1>
            <div class="field">
                <label
                    id="field-sign-label"
                    class="field__label">{{ $t("sign") }}</label>
                <field-select
                    id="field-sign"
                    input-label-id="field-sign-label"
                    @update-value="updateCurrentSign"
                    :options="currentSignOptions"
                    :value="currentSign" ></field-select>
            </div>
        </div>

        <horoscope-gen
            :cycle="cycle"
            :current-sign="currentSign"> </horoscope-gen>
        <div class="container">
            <horoscope-text
                :cycle="cycle"
                :current-sign="currentSign"> </horoscope-text>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src


import {getHoroscope} from "@/utils/api/usersApi.js";

import HoroscopeGen from "@/components/horoscope/HoroscopeGen.vue";
import HoroscopeText from "@/components/horoscope/HoroscopeText.vue";

import FieldSelect from "@/components/forms/FieldSelect.vue";

export default {
    name: "Widget",
    components : {
        HoroscopeGen : HoroscopeGen,
        HoroscopeText : HoroscopeText, 
        FieldSelect : FieldSelect
    }, 
    data() {
        return {
            fetchCycleTentative : 0,
            cycle : null, 
            currentSign : "sc",
            currentSignOptions: [
                {
                    "value": "ar",
                    "label": this.$t("ar")
                },
                {
                    "value": "ta",
                    "label": this.$t("ta")
                },
                {
                    "value": "ge",
                    "label": this.$t("ge")
                },
                {
                    "value": "cn",
                    "label": this.$t("cn")
                },
                {
                    "value": "le",
                    "label": this.$t("le")
                },
                {
                    "value": "vi",
                    "label": this.$t("vi")
                },
                {
                    "value": "li",
                    "label": this.$t("li")
                },
                {
                    "value": "sc",
                    "label": this.$t("sc")
                },
                {
                    "value": "sa",
                    "label": this.$t("sa")
                },
                {
                    "value": "aq",
                    "label": this.$t("aq")
                },
                {
                    "value": "cp",
                    "label": this.$t("cp")
                },
                {
                    "value": "pi",
                    "label": this.$t("pi")
                }
            ]            
        };
    },
    computed : {
        loggedUserId() {
            return this.$store.getters["userModule/getUser"].id_person;
        },
    },
    mounted () {
        this.fetchCycle();
    },
    methods : {
        updateCurrentSign(value) {
            this.currentSign = value;
        },
        fetchCycle() {
            this.fetchCycleTentative += 1;

            
            const user = {
                "id": this.loggedUserId
            };

            getHoroscope(user).then((res) => {
                if (res.status === 200 && res.data) {
                    this.cycle = res.data;
                } else {
                    // If res.data is empty, it maybe bcause the API is still processing data (after a getMeCircleFirstTime call), try again to fetch data.
                    if (this.fetchCycleTentative <= 15 && (!res.data || (res.data && res.data.length === 0))) {
                        this.fetchCycle();
                    } else {
                        // Handle Error
                        let message = this.$t("a-server-error-occured-please-try-later");
                        this.loggedUserId = null;
                        this.$notificationsBar.alert(message, {type: "warning"});
                    }
                }
            });
        },
    }
};
</script>
